<template>
  <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

    <div class="page1" v-for="itm in lng" :key="itm">
      <div class="subpage">
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <p class="text-center"><span> كشف حساب  </span> <span> : </span> <span> {{name}} </span> </p>
            <p class="text-center">{{ classyearsN}}</p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>
        <div class="bd">
           <table class="table  table-bordered p-0">
      <thead class="">
          <tr>
              <td>قيمة الاشتراك</td>
              <td>المبلغ المسدد</td>
              <td>الباقى</td>
          </tr>
      </thead>
      <tbody>
          <tr>
              <td> {{totals}} </td>
              <td> {{total}} </td>
              <td> {{resume}} </td>
          </tr>
      </tbody>
  </table>
          <table class="table">
            <thead>
              <tr>
                <th>م</th>
                <th>الكود </th>
                <th>المبلغ المدفوع</th>
                <th>تاريخ الدفع</th>
                <th>طريقة الدفع</th>
                <th> رقم الشيك</th>

              </tr>
            </thead>
            <tbody>
                
              <tr v-for="rw in cunt" :key="rw" >
             
                <td >{{ inx }}</td>
                <td>{{ loadsub[indx].id}}</td>
                <td>{{ loadsub[indx].amount}}</td>
                <td>{{ loadsub[indx].payDate}}</td>
                <td >{{ loadsub[indx].pType}}</td>
                <td>{{ loadsub[indx].check}}</td>
            
               
                {{
                   addnum(indx, itm) 

                }}
                <!-- <td v-if="addnum()" ></td> -->
              </tr>
              <tr>
<td></td> 
                <td><span> المجموع </span></td>
                <td class="total"> <span>{{total }} </span> <span>ريال</span></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="row">
          <div class="col-4">
            <span>رقم الصفحة </span>
            <span>{{ itm }}</span>
            <span> | </span>
            <span> {{ lng }} </span>
          </div>
          <div class="col-4 "></div>
          <div class="col-4">
            <span>التاريخ</span>
            <span> / </span>
            <span>{{dt}} </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import reportsLayout from "../../layouts/reportsLayout.vue";
import $ from "jquery";
export default {
  name: "depitByBusR",
  data() {
    return {

      lng: 0,
      datalng: 0,
      cunt: 10,
      indx: 0,
      kwd: 0,
      dt:'',
      inx:1,
      sst:'',
      ppt:'',
      total:0,
      totals:0,
      resume:0,
      loadsub:[],
    };
  },
  props:['classyearsID','classyearsN','stdID','name'],
  computed: {
    ...mapGetters({
      std: "stdMod/GET_STDALL",
      payment: "payMod/GET_ALLDATA",
      patype: "GET_PAYTYPE",
    })
  },
 async created() {
    this.$emit("update:layout", reportsLayout);
    await this.LoadData();
    this.loadDate();
    this.reportLoad();
  },
  methods: {
   
    LoadData() {
      
         var id =0;
         var amount =0;
         var payDate =''; 
           var pType = ''; 
           var check=''; 
          var stotal=0; 
        /*for loop */

        
        /* */
        if(this.stdID != null){
            
          const vm = this;
          let list=[];
           var ld= vm.std.find((t)=>t.id == this.stdID);
           this.totals = ld.AmountSub;

           var kk = vm.payment.filter((t)=>t.stdID == this.stdID && t.classyears == this.classyearsID);
            $.each(kk, function () {
            id = ld.id;
            amount = this.amount;
            payDate = this.payDate;
            pType = vm.patype.find((t)=>t.id == this.payType);
            pType = pType.pType;
            check = this.check;
            stotal += parseFloat(amount);

 list.push({
               "id":id,
               "amount":amount,
               "payDate":payDate,
               "pType":pType,
               "check":check

           });
           
           });
        this.total = stotal;
        this.resume = this.totals - this.total;
        this.loadsub = list;
        } 
        
        
    }
    ,paymt(stdID,busId){
        var payT=0;
           var kk = this.payment.filter((t)=>t.stdID == stdID && t.busID == busId && t.classyears == this.classyearsID);
              $.each(kk, function () {
               payT += parseFloat(this.amount);
            });
            return payT;
    },
    reportLoad() {
      if (this.loadsub != null) {
        this.indx = this.loadsub.length - 1;
        var lln = Math.floor(this.loadsub.length / this.cunt);
        if (lln < 1) {
          this.cunt = this.loadsub.length ;
          this.lng = 1;
        } else {
          this.lng = Math.ceil(this.loadsub.length / this.cunt);
          var ss = this.cunt * lln;
          this.kwd = this.loadsub.length - ss;
        }
       
        //window.print();
      }
    }, addnum: function(indx, itm) {
      
     this.inx += 1; 

    this.indx = this.indx - 1 
    
      if (itm == this.lng) {

        if (this.kwd > 1) {
            
          if (this.indx == this.kwd - 1) {
           
           this.cunt = this.indx;
          }

        } else if(this.kwd == 1) {

          if (this.indx == 1) {
            this.cunt = 1;
          }
          
        }
      }
      /* var chk = this.loadsub[indx].id;
      if(chk == 'undefind'){
      this.indx = chkV;
      } */
    },
    prt() {
      window.print();
    },
    loadDate(){
      const event = new Date();
       const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
     this.dt = event.toLocaleDateString('ar-SA', options);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";
.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
}
thead{
 background-color: #d4d4d4; 
}
.total{
    background-color: yellow;
}
</style>
